import React, { FC } from 'react'
import DownArrowIcon from 'transfix-icons/build/DownArrowIcon'
import { Typography, CardContent, makeStyles, createStyles, Box } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { DedicatedLanesResponse } from 'apps/marketplace/apiTypes/dedicatedLanes'

interface IExpandLaneOffersProps {
  onClickShowMoreMatches: () => void
  dedicatedLanes: DedicatedLanesResponse[]
}

type TClassKey = 'cardFooter'

interface IExpandLaneOffersStylesProps {}

const useExpandLaneOffersStyles = makeStyles(theme =>
  createStyles<TClassKey, IExpandLaneOffersStylesProps>({
    cardFooter: {
      color: brandColors.coolGray5,
      borderTop: `1px solid ${brandColors.coolGray4}`,
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        background: brandColors.coolGray1,
        cursor: 'pointer',
      },
      '&:last-child': {
        paddingBottom: theme.spacing(2),
      },
    },
  })
)

export const ExpandLaneOffers: FC<IExpandLaneOffersProps> = ({
  onClickShowMoreMatches,
  dedicatedLanes = [],
}) => {
  const additionalOffersCount = dedicatedLanes.length > 1 ? dedicatedLanes.length - 1 : 0
  const classes = useExpandLaneOffersStyles()
  return (
    <CardContent onClick={onClickShowMoreMatches} className={classes.cardFooter}>
      <DownArrowIcon size='large' />
      <Box paddingLeft={2}>
        <Typography variant='button'>{additionalOffersCount} more matching lanes</Typography>
      </Box>
    </CardContent>
  )
}
